import { defineStore } from "pinia"
import axios from "axios"

export const useAuthStore = defineStore("auth", {
  state: () => ({
    token: null,
    permission: null,
    adminId: null
  }),
  getters: {
    isLoggedIn: (state) => !!state.token,
    isAdminRole: (state) => state.permission === 'admin' || state.permission === 'super_admin',
    isSuperAdmin: (state) => state.permission === 'super_admin'
  },
  actions: {
    async login(username, password, otpCode) {
      const payload = { username, password }
      if (otpCode) payload.otp_code = otpCode
      const res = await axios.post("/api/login", payload)
      this.token = res.data.token
      this.permission = res.data.permission
      this.adminId = res.data.admin_id
      localStorage.setItem("auth", JSON.stringify({ token: this.token, permission: this.permission, adminId: this.adminId }))
      axios.defaults.headers.common.Authorization = `Bearer ${this.token}`
    },
    hydrate() {
     const raw = localStorage.getItem("auth")
     if (!raw) return
     const { token, permission, adminId } = JSON.parse(raw)
     this.token = token || null
     this.permission = permission || null
     this.adminId = adminId || null
     if (this.token) axios.defaults.headers.common.Authorization = `Bearer ${this.token}`
   },
    logout() {
      this.token = null
      this.permission = null
      this.adminId = null
      localStorage.removeItem("auth")
      delete axios.defaults.headers.common.Authorization
    }
  }
})
